<template>
    <vue-draggable-resizable
        v-if="type==='text'"
        :w="textMaxWidth"
        :h="textMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        class-name="text-drag-form vdr"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
    >
        <v-textarea
            :label="currentLabel"
            class="pdftextfield"
            outlined
            rows="1"
            auto-grow
            wrap="off"
            :background-color="bgColorsIdMap[currentDestinationId]"
            hide-details
            :color="colorsIdMap[currentDestinationId]"
            v-model="currentValue"
            disabled
            :height="textMaxHeight"
        >
        </v-textarea>
        <span class="close-btn" v-on:click="close"><v-icon>mdi-close</v-icon></span>
        <span class="move-btn drag-handle"><v-icon>mdi-arrow-all</v-icon></span>
        <v-menu
            v-model="textMenu"
            :close-on-content-click="false"
            class="input_field_dialog"
            right
            nudge-top="213"
            nudge-right="50"
            max-width="250"
        >
            <template v-slot:activator="{ on, attrs }">
                <span class="edit-btn" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></span>
            </template>
            <template-text-edit-area-document-component
                :destinationId="currentDestinationId"
                :destinations="destinations"
                :currentLabel="currentLabel"
                @changeUserId="changeUserId"
                @changeLabel="changeLabel"
            >
            </template-text-edit-area-document-component>
        </v-menu>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='select'"
        :w="selectMaxWidth"
        :h="selectMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        class-name="text-drag-form vdr"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
    >
        <v-select
          v-model="currentValue"
          class="pdfselectfield"
          :items="currentSelectItems"
          :label="currentLabel"
          :background-color="bgColorsIdMap[currentDestinationId]"
          :color="colorsIdMap[currentDestinationId]"
          :readonly="createUserId!==currentDestinationId"
          no-data-text=""
          v-on:change="updateValue"
          outlined
          :height="selectMaxHeight"
          min-height="0"
          disabled
          hide-details="auto"
        >
            <template v-slot:item="{ item }">
               <span class="pdfselectitem">{{ item }}</span>
            </template>
        </v-select>
        <span class="close-btn" v-on:click="close"><v-icon>mdi-close</v-icon></span>
        <span class="move-btn drag-handle"><v-icon>mdi-arrow-all</v-icon></span>
        <v-menu
            v-model="selectMenu"
            :close-on-content-click="false"
            class="input_field_dialog"
            right
            nudge-top="470"
            nudge-right="50"
            max-width="250"
        >
            <template v-slot:activator="{ on, attrs }">
                <span class="edit-btn" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></span>
            </template>
            <select-edit-area-component
                :destinationId="currentDestinationId"
                :destinations="destinations_non_sender"
                :currentLabel="currentLabel"
                :items="currentSelectItems"
                :currentValue="currentValue"
                type="template"
                @changeUserId="changeUserId"
                @changeLabel="changeLabel"
                @addSelectItem="addSelectItem"
                @delSelectItem="delSelectItem"
            >
            </select-edit-area-component>
        </v-menu>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='checkbox'"
        :w="checkboxMaxWidth"
        :h="checkboxMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
        class-name="checkbox-drag-form vdr"
        :style="{backgroundColor: bgColorsIdMap[currentDestinationId]}"
    >
        <label class="checkbox-input">
            <input 
                type="checkbox"
                v-model="currentDefault"
                disabled
            >
            <span class="checkbox-image"></span>
         </label>
        <span class="close-btn" v-on:click="close"><v-icon>mdi-close</v-icon></span>
        <span class="move-btn drag-handle"><v-icon>mdi-arrow-all</v-icon></span>
        <v-menu
            v-model="checkboxMenu"
            :close-on-content-click="false"
            class="input_field_dialog"
            right
            nudge-top="202"
            nudge-right="50"
            max-width="300"
        >
            <template v-slot:activator="{ on, attrs }">
                <span class="edit-btn" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></span>
            </template>
            <template-checkbox-edit-area-component
                :destinationId="currentDestinationId"
                :destinations="destinations_non_sender"
                :require="currentRequired"
                :defaultValue="currentDefault"
                @changeUserId="changeUserId"
                @changeRequire="changeRequire"
            >
            </template-checkbox-edit-area-component>
        </v-menu>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='seal' || type==='square-seal'"
        :key="time"
        :w="sealMaxWidth"
        :h="sealMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        :x='currentX'
        :y='currentY'
        @dragstop="onDrag"
        class-name="seal-drag-form vdr"
        :style="bgStyle"
    >
        <v-dialog
            v-model="sealDialog"
            width="fit-content"
        >
            <template v-slot:activator="{ on, attrs}">
                <v-img
                    :width="sealImageWidth"
                    :height="sealImageHeight"
                    :src="currentSealData"
                    :contain="true"
                    v-bind="attrs"
                    v-on="on"
                    v-show="currentSealData != ''"
                    class="seal-preview"
                >
                </v-img>
                <span
                    class="circle"
                    :style="'border: solid 3px '+colorsIdMap[currentDestinationId]"
                    v-bind="attrs"
                    @click="sealAreaClick"
                    v-show="currentSealData === ''"
                >
                </span>
            </template>
            <template>
              <v-tabs v-model="tab">
                <v-tab>印影の選択</v-tab>
                <v-tab>印影の作成</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <seal-input-dialog-component
                        @cancelSeal="cancelSeal"
                        @registerSeal="registerSeal"
                    >
                    </seal-input-dialog-component>
                  </v-tab-item>
                  <v-tab-item>
                    <add-seal-input-dialog-component
                        :key="currentDestinationId"
                        :type="sealType"
                        :x="x"
                        :y="y"
                        :sealText="currentSealText"
                        :direction="currentDirection"
                        @cancelSeal="cancelSeal"
                        @registerSeal="registerSeal"
                        @changeSealText="changeSealText"
                        @changeSealDirection="changeSealDirection"
                        @changeSealType="changeSealType"
                    >
                    </add-seal-input-dialog-component>
                  </v-tab-item>
                </v-tabs-items>
            </template>
        </v-dialog>
        <span class="close-btn" v-on:click="close"><v-icon>mdi-close</v-icon></span>
        <span class="move-btn drag-handle"><v-icon>mdi-arrow-all</v-icon></span>
        <v-menu
            v-model="sealMenu"
            :close-on-content-click="false"
            class="input_field_dialog"
            right
            nudge-top="272"
            nudge-right="50"
            max-width="250"
        >
            <template v-slot:activator="{ on, attrs }">
                <span class="edit-btn" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></span>
            </template>
            <seal-edit-area-component
                ref="sealarea"
                :destinationId="currentDestinationId"
                :destinations="destinations_seal"
                @openSelectSealDialog="openSelectSealDialog"
                @changeUserId="changeUserId"
            >
            </seal-edit-area-component>
        </v-menu>
    </vue-draggable-resizable>
</template>

<script>
    import { getTextSize } from '../../common/textUtil.js';
    import { getImgInfo } from '../../common/imageUtil.js';
    import AddSealInputDialogComponent from '../contractInput/AddSealInputDialogComponent.vue';
    export default {
        props: [
            'type',
            'destinations',
            'x',
            'y',
            'value',
            'label',
            'required',
            'defaultValue',
            'destinationId',
            'objectId',
            'page',
            'pdfId',
            'color',
            'colorsIdMap',
            'bgColorsIdMap',
            'createUserId',
            'pdfWidth',
            'pdfHeight',
            'selectItems',
            'sealText',
            'direction',
        ],
        components: {
            'add-seal-input-dialog-component': AddSealInputDialogComponent,
        },
        data() {
            return {
                textMaxWidth: 200,
                textMaxHeight:29.5,
                selectMaxWidth: 200,
                selectMaxHeight:29.5,
                checkboxMaxWidth: 40,
                checkboxMaxHeight: 43,
                sealMaxWidth: 60,
                sealMaxHeight: 65,
                sealImageWidth: 40,
                sealImageHeight: 40,
                currentDestinationId: 0,
                currentValue: '',
                currentLabel: '',
                currentRequired: false,
                currentDefault: false,
                isShowEditArea: false,
                isReadOnly: true,
                textMenu: false,
                selectMenu: false,
                checkboxMenu: false,
                sealMenu: false,
                sealDialog: false,
                currentSealData: '',
                currentSealText: '',
                currentDirection: 0,
                currentX: 0,
                currentY: 0,
                defaultX: 0,
                defaultY: 0,
                deleted: false,
                checkValue: false,
                currentSelectItems: [],
                tab: null,
                sealType: '',
                time: new Date().getTime(),
            };
        },
        computed: {
            destinations_non_sender : {
                get() {
                    return this.destinations.filter(item => item.is_destination != 0);
                },
                set() {
                }
            },
            destinations_seal : {
                get() {
                    return this.destinations.map(item => {
                        if (item.is_destination == 0){
                            const copyItem = Object.assign({},item);
                            copyItem.destination_user_name = "送信者";
                            return copyItem;
                        }
                        return item;
                    });
                },
                set() {
                }
            },
            bgStyle: {
                get() {
                    if (this.currentSealData === ''){
                        return { backgroundColor: this.bgColorsIdMap[this.currentDestinationId] };
                    }else{
                        return {};
                    }
                },
                set() {}
            },

        },
        created: function () {
            this.currentDestinationId = this.destinationId;
            this.currentValue = this.value? this.value : "";
            this.currentSelectItems = this.selectItems? this.selectItems : [];
            this.currentLabel = this.label;
            this.currentRequired = this.required;
            this.currentDefault = this.defaultValue;
            this.currentSealData = this.value? this.value : "";
            this.currentSealText = this.sealText? this.sealText : "";
            this.currentDirection = this.direction? this.direction : 0;
            this.currentX = this.x;
            this.currentY = this.y;
            this.checkValue = this.currentValue == ''? false : true;
            this.sealType = this.type;
            if (this.type == "seal") {
                let img = getImgInfo(this.currentValue,40)
                img.then(res=>{
                    this.sealImageWidth = res.width
                    this.sealImageHeight = res.height
                    this.sealMaxWidth = res.width + 20
                    this.sealMaxHeight = res.height + 25
                })
            }else if(this.type == "square-seal"){
                let img = getImgInfo(this.currentValue,70)
                img.then(res=>{
                    this.sealImageWidth = res.width
                    this.sealImageHeight = res.height
                    this.sealMaxWidth = res.width + 20
                    this.sealMaxHeight = res.height + 25
                })
            }
        },
        methods: {
            close: function () {
                this.deleted = true
                this.$emit('closeElement', this.pdfId, this.page, this.objectId)
            },
            showEditArea: function (isShow) {
                this.isShowEditArea = isShow
            },
            setReadOnly: function (isReadOnly) {
                this.isReadOnly = isReadOnly
            },
            cancelSeal: function () {
                this.sealDialog = false;
            },
            openSelectSealDialog: function () {
                this.sealDialog = true;
            },
            sealAreaClick: function () {
                if (this.createUserId == this.currentDestinationId) {
                    this.sealDialog = true;
                }
            },
            registerSeal: function (sealData,size,type='seal') {
                this.currentSealData = sealData
                this.currentValue = sealData
                this.sealType = type
                this.sealDialog = false;
                if((size + 20) > (this.pdfWidth - this.defaultX)){
                    this.currentX = this.pdfWidth - (size + 20)
                }else{
                    if(this.defaultX != 0){
                        this.currentX = this.defaultX
                    }
                }
                if((size + 25) > (this.pdfHeight - this.defaultY)){
                    this.currentY = this.pdfHeight - (size + 25)
                }else{
                    if(this.defaultY != 0){
                        this.currentY = this.defaultY
                    }
                }
                this.updateInputDetail()
                let img = getImgInfo(sealData,size)
                img.then(res=>{
                    this.sealImageWidth = res.width
                    this.sealImageHeight = res.height
                    this.sealMaxWidth = res.width + 20
                    this.sealMaxHeight = res.height + 25
                })
                this.time = new Date().getTime();
            },
            changeSealText: function (sealText) {
                this.currentSealText = sealText
                this.updateInputDetail()
            },
            changeSealDirection: function (direction) {
                this.currentDirection = direction
                this.updateInputDetail()
            },
            changeSealType: function (type) {
                this.sealType = type
                this.updateInputDetail()
            },
            changeUserId: function (userId) {
                this.currentDestinationId = userId
                if (this.$refs.sealarea) {
                    if (this.createUserId !== userId) {
                        this.currentSealData = ""
                        this.$refs.sealarea.isDisabled = true
                    } else {
                        this.$refs.sealarea.isDisabled = false
                    }
                } else {
                    this.currentValue = ""
                }
                this.currentSealText = ""
                this.currentDirection = 0
                this.updateInputDetail()
            },
            changeLabel: function (label) {
                this.currentLabel = label
                this.updateInputDetail()
            },
            addSelectItem: function (item) {
                this.currentSelectItems.push(item)
                this.updateInputDetail()
            },
            delSelectItem: function (item) {
                this.updateSelectItems(item)
                if(item == this.currentValue){
                  this.currentValue = "";
                }
                this.updateInputDetail()
            },
            changeRequire: function (require) {
                this.currentRequired = require
                this.updateInputDetail()
            },
            onDrag:async function (x, y) {
                this.currentX = x
                this.currentY = y
                if(90 > (this.pdfWidth - x) || x == 0){
                    this.defaultX = x
                }else{
                    this.defaultX = 0
                }
                
                if(90 > (this.pdfHeight - y) || y == 0){
                    this.defaultY = y
                }else{
                    this.defaultY = 0
                }
                this.updateInputDetail()
                await getTextSize(this.currentValue).then( value => {
                    if(value.textMaxWidth >= (this.pdfWidth - this.currentX)){
                        this.textMaxWidth = this.pdfWidth - this.currentX
                    }
                  })
            },
            updateValue: function (e) {
                if (this.type == "select") {
                    this.currentValue = e
                }else{
                    this.currentValue = e.target.value
                }
                this.updateInputDetail()
            },
            updateInputDetail: function () {
                this.$emit("updateInputDetail",
                    this.page,
                    this.objectId,
                    this.sealType,
                    this.currentDestinationId,
                    this.currentValue,
                    this.currentLabel,
                    this.currentRequired,
                    this.currentDefault,
                    Math.floor(this.currentX),
                    Math.floor(this.currentY),
                    this.deleted,
                    this.colorsIdMap[this.currentDestinationId],
                    this.currentSelectItems,
                    this.currentSealText,
                    this.currentDirection
                )
            },
            updateSelectItems: function (item) {
              let currentSelectItems = new Set(this.currentSelectItems)
                currentSelectItems.delete(item)
                this.currentSelectItems = [...currentSelectItems]  
            }
        },
        watch: {
            currentValue:async function(newVal, oldVal) {
                if (this.type == "text") {
                     await getTextSize(newVal).then( value => {
                          this.textMaxWidth = value.textMaxWidth
                          this.textMaxHeight = value.textMaxHeight
                          this.$el.style.setProperty("--textMaxHeight", value.textMaxHeight + 'px');
                      })
                }
            }
        },
        mounted: function () {
            this.$el.style.setProperty("--textMaxHeight", this.textMaxHeight + 'px')
            this.$el.style.setProperty("--selectMaxHeight", this.selectMaxHeight + 'px')
        },
    }

</script>

<style scoped>
    .circle{
      display: inline-block;
      margin: 9px;
      width: 40px;
      height: 40px;
      text-align:center;
      line-height: 40px;
      border-radius: 50%;
      border: solid 3px blue;
      background-color: #FFF;
    }

    .close-btn {
      position: absolute;
      top: -12px;
      right: -12px;
      width: 24px;
      height: 24px;
      background: #ff9999;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .close-btn:hover {
      background: #ff9999;
    }

    .move-btn {
      position: absolute;
      bottom: -12px;
      right: -12px;
      width: 24px;
      height: 24px;
      background: #a0e0ff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .move-btn:hover {
      background: #a0e0ff;
    }

    .edit-btn {
      position: absolute;
      bottom: -12px;
      right: 14px;
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .edit-btn:hover {
      background: #fff;
    }

    .text-drag-form {
      border: none;
    }

    .checkbox-drag-form {
    }


    .seal-drag-form {
    }

    .seal-preview {
        margin: 9px;
    }
    
    .pdftextfield::v-deep .v-input__slot {
        min-height:var(--textMaxHeight);
    }
    
    .pdftextfield::v-deep .v-label {
        top:3px !important;
        font-size: 1.6rem !important;
    }
    
    .pdftextfield::v-deep .v-label--active {
        transform: translateY(-12px) scale(.75);
    }

    .input_field_dialog {
      z-index: 101;
    }
    
    .pdfselectfield {
        font-family: 'IPAexゴシック';
    }
    
    .pdfselectfield::v-deep .v-input__slot {
        min-height:var(--selectMaxHeight);
        font-size: 10.5px !important;
    }
    
    .pdfselectfield::v-deep .v-input__append-inner {
        margin-top: 0px !important;
    }
    
    .pdfselectfield::v-deep .v-select__selection--comma {
        margin: 0 !important;
        overflow: hidden;
        max-width: 100%;
        text-overflow: unset;
    }
    
    .pdfselectfield::v-deep .v-select__selections {
        flex-wrap: unset;
    }
    
    .pdfselectitem {
        font-size: 10.5px !important;
    }
    
    ::v-deep .theme--light.v-list-item { 
        min-height: 0 !important;
    }
    
    .pdfselectfield::v-deep .v-label {
        top:3px !important;
        font-size: 1.6rem !important;
        color: rgba(0, 0, 0, 0.6) !important
    }
    
    .pdfselectfield::v-deep .v-label--active {
        transform: translateY(-12px) scale(.75);
        color: rgba(0, 0, 0, 0.6) !important
    }
</style>